import {
  pageInfo,
  batchLocking,
  initUpdate,
  batchCancelLocking,
  batchDepositCheck,
  batchCancelDepositCheck,
  batchReceivablesCheck,
  batchCancelReceivablesCheck,
  batchTotalProfitCheck,
  batchCancelTotalProfitCheck,
  downloadTemplate,
  batchLockingImport,
  orderReceivableEdit,
  exportData,
  selectTotalProfit,
  initPage,
  transferPersonnelEdit
} from './../api';
import {getExpensesAreasOptionInfo, market, marketTravelAgency, selectTravelStatus, orderUserNo } from "../../../../api";
const orderSearch = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    deleteResp: null,
    initPageObj: null,
    initUpdateObj: null,
    carrierInfoObj: null,
    travelStatusObj: null,
    expensesAreasOptionObj: null,
    batchCancleLockingObj: null,
    batchDepositObj: null,
    batchCancleDepositObj: null,
    batchReceivablesObj: null,
    batchTotalProfitCheckObj: null,
    batchCancelTotalProfitCheckObj: null,
    templateObj: null,
    batchLockingObj: null,
    batchLockingImportObj: null,
    orderReceivableObj: null,
    exportObj: null,
    totalProfitObj: null,
    orderUserNoObj: null,
    transferPersonnelObj: null
  },
  mutations: {
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj
    },
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj.map(item=> ({...item, btns:[true, item.travelStatusNo == 'TS000' || item.receivablesCheckFlag == 'Y' || item.totalProfitCheckFlag == 'Y' ? true : true]}));
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    MARKET_DATA(state,data) {
      state.marketObj = data;
    },
    MARKET_TRAVEL_AGENCY_DATA(state,data) {
      state.marketTravelAgencyObj = data;
    },
    TRAVEL_STATUS_DATA(state,data) {
      state.travelStatusObj = data;
    },
    EXPENSES_AREAS_OPTION_DATA(state,data) {
      state.expensesAreasOptionObj = data;
    },
    BATCH_LOCKING_DATA(state,data) {
     state.batchLockingObj = data;
    },
    BATCH_CANCLE_LOCKING_DATA(state,data) {
      state.batchCancleLockingObj = data;
    },
    BATCH_DEPOSIT_CHECK_DATA(state,data) {
      state.batchDepositObj = data;
    },
    BATCH_CANCEL_DEPOSIT_CHECK_DATA(state,data) {
      state.batchCancleDepositObj = data;
    },
    BATCH_RECEIVABLES_CHECK_DATA(state,data) {
      state.batchReceivablesObj = data;
    },
    BATCH_CANCEL_RECEIVABLES_CHECK_DATA(state,data) {
      state.batchCancleReceivablesObj = data;
    },
    BATCH_TOTAL_PROFIT_CHECK_DATA(state,data) {
      state.batchTotalProfitCheckObj = data;
    },
    BATCH_CANCEL_TOTAL_PROFIT_CHECK_DATA(state,data) {
      state.batchCancelTotalProfitCheckObj = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    BATCH_LOCKING_IMPORT(state, data) {
      state.batchLockingImportObj = data;
    },
    ORDER_RECEIVABLE_EDIT_DATA(state, data) {
      state.orderReceivableObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    SELECT_TOTAL_PROFIT_DATA(state, data) {
      state.totalProfitObj = data;
    },
    ORDER_USERNO_DATA(state, data) {
      state.orderUserNoObj = data;
    },
    TRANSFER_PERSONNEL_EDIT_DATA(state, data) {
      state.transferPersonnelObj = data;
    },
},
  actions: {
    //初始化
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化更新对象事件
    async editDetails({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //市场下拉框
    async market({commit}, obj){
      let resp = await market(obj);
      commit('MARKET_DATA', resp);
    },
    //地接社下拉框
    async marketTravelAgency({commit}, obj){
      let resp = await marketTravelAgency(obj);
      commit('MARKET_TRAVEL_AGENCY_DATA', resp);
    },
    //行程状态下拉框
    async selectTravelStatus({commit}, obj){
      let resp = await selectTravelStatus(obj);
      commit('TRAVEL_STATUS_DATA', resp);
    },
    //业务员下拉框
    async selectOrderUserNo({commit}, obj){
      let resp = await orderUserNo(obj);
      commit('ORDER_USERNO_DATA', resp);
    },
    //根据市场ID查询地接社
    async getExpensesAreasOptionInfo({commit}, obj){
      let resp = await getExpensesAreasOptionInfo(obj);
      commit('EXPENSES_AREAS_OPTION_DATA', resp);
    },
    //批量锁定
    async batchLocking({commit}, obj){
      let resp = await batchLocking(obj);
      commit('BATCH_LOCKING_DATA', resp);
    },
    //取消批量锁定
    async batchCancelLocking({commit}, obj){
      let resp = await batchCancelLocking(obj);
      commit('BATCH_CANCLE_LOCKING_DATA', resp);
    },
    //定金核对
    async batchDepositCheck({commit}, obj){
      let resp = await batchDepositCheck(obj);
      commit('BATCH_DEPOSIT_CHECK_DATA', resp);
    },
    //定金取消核对
    async batchCancelDepositCheck({commit}, obj){
      let resp = await batchCancelDepositCheck(obj);
      commit('BATCH_CANCEL_DEPOSIT_CHECK_DATA', resp);
    },
    //应收款核对
    async batchReceivablesCheck({commit}, obj){
      let resp = await batchReceivablesCheck(obj);
      commit('BATCH_RECEIVABLES_CHECK_DATA', resp);
    },
    //应收款取消核对
    async batchCancelReceivablesCheck({commit}, obj){
      let resp = await batchCancelReceivablesCheck(obj);
      commit('BATCH_CANCEL_RECEIVABLES_CHECK_DATA', resp);
    },
    //总利润核对
    async batchTotalProfitCheck({commit}, obj){
      let resp = await batchTotalProfitCheck(obj);
      commit('BATCH_TOTAL_PROFIT_CHECK_DATA', resp);
    },
    //总利润取消核对
    async batchCancelTotalProfitCheck({commit}, obj){
      let resp = await batchCancelTotalProfitCheck(obj);
      commit('BATCH_CANCEL_TOTAL_PROFIT_CHECK_DATA', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //导入
    async batchLockingImport({ commit }, obj) {
      let resp = await batchLockingImport(obj);
      commit('BATCH_LOCKING_IMPORT', resp);
    },
    //应收款调整
    async orderReceivableEdit({ commit }, obj) {
      let resp = await orderReceivableEdit(obj);
      commit('ORDER_RECEIVABLE_EDIT_DATA', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //查询总利润
    async selectTotalProfit({ commit }, obj) {
      let resp = await selectTotalProfit(obj);
      commit('SELECT_TOTAL_PROFIT_DATA', resp);
    },
    //转员处理
    async transferPersonnelEdit({ commit }, obj) {
      let resp = await transferPersonnelEdit(obj);
      commit('TRANSFER_PERSONNEL_EDIT_DATA', resp);
    },
  }
}
export default orderSearch



// WEBPACK FOOTER //
// ./src/page/financial/orderLocking/store/orderLocking.store.js